// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../../assets/images/button_icons/close.svg");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rYGfq219lut_etLoLEHZ {
    all: unset;
    background: #ffffff;
    border-radius: 99999px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: 12px;
    background-position: center;
    background-repeat: no-repeat;
    width: 20px;
    height: 20px;
    border: var(--map-popup-border);
    cursor: pointer;
    position: absolute;
    top: -8px;
    right: -8px;
    pointer-events: auto;
    cursor: pointer;
    z-index: 1;
    transition: opacity 150ms ease;
}

#map-container.gw-map-dragging .rYGfq219lut_etLoLEHZ {
  opacity: 0.85;
}`, "",{"version":3,"sources":["webpack://./../core/components/popups/PopupCloseButton.module.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,mBAAmB;IACnB,sBAAsB;IACtB,yDAAuD;IACvD,qBAAqB;IACrB,2BAA2B;IAC3B,4BAA4B;IAC5B,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,oBAAoB;IACpB,eAAe;IACf,UAAU;IACV,8BAA8B;AAClC;;AAEA;EACE,aAAa;AACf","sourcesContent":[".popUpCloseButton {\r\n    all: unset;\r\n    background: #ffffff;\r\n    border-radius: 99999px;\r\n    background-image: url(\"@images/button_icons/close.svg\");\r\n    background-size: 12px;\r\n    background-position: center;\r\n    background-repeat: no-repeat;\r\n    width: 20px;\r\n    height: 20px;\r\n    border: var(--map-popup-border);\r\n    cursor: pointer;\r\n    position: absolute;\r\n    top: -8px;\r\n    right: -8px;\r\n    pointer-events: auto;\r\n    cursor: pointer;\r\n    z-index: 1;\r\n    transition: opacity 150ms ease;\r\n}\r\n\r\n:global(#map-container.gw-map-dragging) .popUpCloseButton {\r\n  opacity: 0.85;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popUpCloseButton": `rYGfq219lut_etLoLEHZ`
};
module.exports = ___CSS_LOADER_EXPORT___;
